import {
    AddDatasetUddannelsessteder,
    AddDatasetUddannelsesstederActions
} from "./components/addDatasetUddannelsessteder";
import {Loading} from "../../core/components/loading/loading";
import {Localizer} from "../../infrastructure/localization/localizer";
import {toDate} from "../../index";
import {EvalueringsstatistikPageConstants} from "./components/EvalueringsstatistikPageConstants";
import {AddDatasetFilteringActions, AddFilteringDataset} from "./components/addDatasetFiltering";
import React, {useState} from "react";
import {useAppSelector} from "../../app/hooks";
import {evalueringsstatistikFiltersReducer, EvalueringsstatistikFiltersState} from "./evalueringsstatistikFiltersSlice";
import {SlideIn} from "../../core/components/slideIn/slideIn";
import {ModalSize} from "../../core/components/slideIn/modalSize";

type EvalueringsstatistikFilteringProps = {
    modalId: string;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
    openModal: boolean;
    isEditView?: boolean;
    setOpenModal: (open: boolean) => void;
    searchSavedUpdatedCallback?: () => void;
}
export const EvalueringsstatistikFiltering = ({
                                                  modalId,
                                                  setIsLoading,
                                                  isLoading,
                                                  openModal,
                                                  setOpenModal,
                                                  isEditView = false,
                                                  searchSavedUpdatedCallback
                                              }: EvalueringsstatistikFilteringProps) => {

    const [page, setPage] = useState<number>(1);
    const evalueringsstatistikFilterSliceState = useAppSelector(evalueringsstatistikFiltersReducer) as EvalueringsstatistikFiltersState;
    const {slutDato, startDato} = evalueringsstatistikFilterSliceState;

    const handleNextClick = () => {
        if (page === 1) {
            setPage(2);
        }
    }

    const handleBackClick = () => {
        if (page === 2) {
            setPage(1);
        }
    }

    const closeAddDatasetModal = () => {
        setOpenModal(false);
        setPage(1);
    }


    return (
        <div>
            {openModal &&
                <SlideIn
                    id={modalId}
                    title={Localizer.evalueringsstatistikPage_editSavedSearch()}
                    actionFinishedCallback={closeAddDatasetModal}
                    actionOnCloseCallback={closeAddDatasetModal}
                    bodyContent={<>
                        {page === 1
                            ?
                            <AddDatasetUddannelsessteder modalId={modalId}/>
                            :
                            <Loading isLoading={isLoading}
                                     text={Localizer.evalueringsstatistikPage_addDataset()}
                                     timeout={100}
                                     extraLoadingInfo={slutDato && startDato && (toDate(slutDato).getUTCFullYear() - toDate(startDato).getUTCFullYear()) > EvalueringsstatistikPageConstants.periodLengthInYears
                                         ? Localizer.evalueringPage_henterStortDataset()
                                         : ""}>
                                <AddFilteringDataset
                                    modalId={modalId}
                                    setIsLoading={setIsLoading}
                                    isEditView={isEditView}
                                    fortryd={closeAddDatasetModal}
                                    searchSavedUpdatedCallback={searchSavedUpdatedCallback}
                                />
                            </Loading>
                        }
                    </>}
                    defaultOpen={true}
                    modalSize={ModalSize.md}
                    footerContent={page === 1
                        ? <AddDatasetUddannelsesstederActions modalId={modalId} next={handleNextClick}/>
                        :  <AddDatasetFilteringActions modalId={modalId} back={handleBackClick} hideTilfoej={isEditView} />
                    }
                    additionalFooterClasses={"justify-content-between"}
                />
            }
        </div>
    )
}
